import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { WORDS } from '../../routes/routeConstant'
import { dismissWordsCallout, isWordsCalloutDismissed } from '../../utils/wordsDiscovery'
import './wordsDiscoveryCallout.css'

/**
 * Surfaced on the story-finished screen the first time(s) a paid user
 * completes a story. Leads with the outcome (better-matched recommended
 * stories from the existing library) and persists "discovered" state in
 * localStorage. Hides itself once the user dismisses it, clicks the CTA,
 * or visits the Words page through any other entry point.
 *
 * Visually it follows the same centered, no-card pattern used for "Read
 * Again" and "Track your Streaks" — separated only by a subtle hairline
 * divider so it reads as a natural extension of the screen.
 */
const WordsDiscoveryCallout: React.FC = () => {
  const { t } = useTranslation('dashboard')
  const navigate = useNavigate()
  const [hidden, setHidden] = useState<boolean>(() => isWordsCalloutDismissed())

  if (hidden) return null

  const handleDismiss = () => {
    dismissWordsCallout()
    setHidden(true)
  }

  const handleOpenWords = () => {
    dismissWordsCallout()
    navigate(WORDS)
  }

  return (
    <div className='words-discovery-callout'>
      <p className='words-discovery-callout__title'>{t('wordsCallout.title')}</p>
      <p className='words-discovery-callout__body'>
        <Trans t={t} i18nKey='wordsCallout.body' components={{ strong: <strong /> }} />
      </p>
      <p className='m-link color-primary m-b words-discovery-callout__cta' onClick={handleOpenWords}>
        {t('wordsCallout.manage')}
      </p>
      <button type='button' className='words-discovery-callout__dismiss' onClick={handleDismiss}>
        {t('wordsCallout.hide')}
      </button>
    </div>
  )
}

export default WordsDiscoveryCallout
